"use client";

import { useEffect } from "react";
import { identifyPosthogUser } from "@/lib/analytics/posthog-client";
import { useAuthSession } from "@/lib/auth/client";

export function PostHogAuthSync() {
  const session = useAuthSession();

  useEffect(() => {
    if (!session.data) {
      return;
    }

    identifyPosthogUser({ session: session.data }).catch(() => {
      // Ignore analytics errors; do not block UI.
    });
  }, [session.data]);

  return null;
}
